import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-chevron-left",
  style: {"fontSize":"1.5rem","color":"black"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { style: {"flex":"1"} }, " Azienda ", -1)
const _hoisted_5 = { class: "p-mx-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LegalEntityMenagement = _resolveComponent("LegalEntityMenagement")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: "javascript:;",
        class: "p-mx-4",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
      }, _hoisted_3),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_LegalEntityMenagement, { onCanGoForward: _ctx.passEmittedValue }, null, 8, ["onCanGoForward"])
    ])
  ], 64))
}